import moment from 'moment'

export const forms = {
  getBaseForm(formData, extend, _this) {
    const getType = (name, type) => {
      if (extend.checkDisabled(name)) {
        return 'text'
      } else {
        return type
      }
    }
    const data = [
      {
        type: getType('grantForm', 'input'),
        label: '金额',
        col: '12',
        id: 'individual_case_support_funds',
        disabled: true,
        lineFeed: true,
        defaultValue: formData.individual_case_support_funds,
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: getType('grantForm', 'input'),
        label: '领取人',
        col: '12',
        id: 'getPerson',
        rules: [
          {
            required: true,
            message: '请填写领取人'
          }
        ],
        lineFeed: true,
        defaultValue: formData.getPerson || '',
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: getType('grantForm', 'datePicker'),
        label: '发放时间',
        rules: [
          {
            required: true,
            message: '请选择发放时间'
          }
        ],
        // disabledDate: (current) => { return current && current >= moment().startOf('day') },
        // disabled: extend.checkDisabled,
        format: 'YYYY-MM-DD',
        lineFeed: true,
        defaultValue: extend.checkDisabled('grantForm')
          ? formData.grant_time
            ? moment(formData.grant_time, 'YYYY-MM-DD').format('YYYY-MM-DD')
            : ''
          : formData.grant_time
            ? moment(formData.grant_time, 'YYYY-MM-DD').format('YYYY-MM-DD')
            : null,
        col: '12',
        id: 'grant_time',
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: getType('grantForm', 'input'),
        label: '与帮扶对象关系',
        col: '12',
        id: 'objectRelational',
        rules: [
          {
            required: true,
            message: '请填写与帮扶对象关系'
          }
        ],
        lineFeed: true,
        defaultValue: formData.objectRelational || '本人',
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: getType('grantForm', 'select'),
        label: '发放方式',
        col: '12',
        id: 'disbursement',
        defaultValue: formData.disbursement || '现金签收',
        rules: [
          {
            required: true,
            message: '发放方式不能为空'
          }
        ],
        lineFeed: true,
        onChange: _this.handleChange,
        options: [
          {
            label: '现金签收',
            value: '现金签收'
          },
          {
            label: '银行汇款',
            value: '银行汇款'
          }
        ],
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: getType('grantForm', 'input'),
        display: formData.disbursement === '银行汇款' ? true : _this.dis,
        label: '银行名称',
        col: '12',
        id: 'whereItIs',
        lineFeed: true,
        rules: [
          {
            required: _this.dis,
            message: '请填写开户行'
          }
        ],
        defaultValue: formData.whereItIs || '',
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: getType('grantForm', 'input'),
        display: formData.disbursement === '银行汇款' ? true : _this.dis,
        label: '银行账号',
        col: '12',
        id: 'bankAccount',
        lineFeed: true,
        rules: [
          {
            pattern: /^[0-9]*$/,
            message: '请输入数字'
          },
          {
            required: _this.dis,
            message: '请填写银行账号'
          }
        ],
        defaultValue: formData.bankAccount || '',
        layout: {
          labelCol: '120px'
        }
      }
    ]
    return data
  }
}
